import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { usePastaEscritorio } from "./hooks";

/**
 * Página do negócio no escritório cliente (preset `atticus_escritorio`): só para pasta paga.
 * Paga, a pasta é um negócio comum (decisão de 03/11). Não paga, volta para a gaveta em /pastas,
 * que tem o checkout. Erro (não é pasta, não é dela) também volta para /pastas.
 *
 * É experiência, não segurança: antes do pagamento o negócio da org do escritório só tem o nome
 * parcial e o valor (`_pasta_entregar`), e o lead nem existe.
 */
export function PastaPagaGuard({ dealId, children }: { dealId: string; children: ReactNode }) {
  const { data, isPending, isError } = usePastaEscritorio(dealId);

  if (isPending) return null;
  if (isError || !data) return <Navigate to="/pastas" replace />;
  if (!data.liberado) return <Navigate to={`/pastas?pasta=${encodeURIComponent(dealId)}`} replace />;
  return <>{children}</>;
}
